(() => {
  const sticky = document.querySelector('[data-calmi-sticky]');
  if (!sticky) return;

  const offer = document.querySelector('#calmi-offer');
  const onScroll = () => {
    const pastHero = window.scrollY > 720;
    const nearOffer = offer ? offer.getBoundingClientRect().top < window.innerHeight * 0.8 : false;
    sticky.classList.toggle('is-visible', pastHero && !nearOffer);
  };

  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();
